import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const ClientDetailPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.clients.pageHeader.titleDetail')} />
}

ClientDetailPageHeader.displayName = 'ClientDetailPageHeader'
export default ClientDetailPageHeader
